// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__pVv_8","label":"styles_label__EtRu_","icon":"styles_icon__NUrWa"};